const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  wsUrl: import.meta.env.VITE_WS_URL,
  oauthUrl: import.meta.env.VITE_OAUTH_URL,
  baseUrl: import.meta.env.VITE_FRONTEND_URL
};

export default config;
